/* eslint-disable no-shadow */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable no-plusplus */
import { InterestPointType } from 'models/repossession/enums/repossession.enums';
import { commonErrorHandler } from 'models/shared/helpers/errors';
import moment from 'moment';
import React, { useEffect, useState, createContext, useMemo } from 'react';
import {
	fetchGeotileHistory,
	fetchGeotilesLocations,
} from 'models/_external/geotile/controllers/geotile.controller';
import { GeotileHistoryLocationDto } from 'models/_external/geotile/interfaces/geotile.interface';
import { ExternalVehicleStatusEnum } from 'models/_external/external-vehicles/enums/external-vehicles.enum';
import { DeviceLocation } from './GeotileMap.constants';

interface GeotileMapContextModel {
	loading: boolean;
	setLoading: React.Dispatch<React.SetStateAction<boolean>>;
	loadingHistory: boolean;
	gpsLocations: DeviceLocation[];
	gpsHistory: GeotileHistoryLocationDto[];
	selectedMarker?: DeviceLocation;
	setSelectedMarker: React.Dispatch<
		React.SetStateAction<DeviceLocation | undefined>
	>;
	clearContext: () => void;
}

export const geotileMapContext = createContext<GeotileMapContextModel>({
	loading: false,
} as any);

export const GeotileMapContextProvider = ({ children }: { children: any }) => {
	const [loading, setLoading] = useState<boolean>(false);
	const [loadingHistory, setLoadingHistory] = useState<boolean>(false);

	const [gpsLocations, setGpsLocations] = useState<DeviceLocation[]>([]);
	const [gpsHistory, setGpsHistory] = useState<GeotileHistoryLocationDto[]>([]);
	const [selectedMarker, setSelectedMarker] = useState<DeviceLocation>();

	const clearContext = () => {
		setGpsLocations([]);
		setGpsHistory([]);
		setSelectedMarker(undefined);
		initializeContext();
	};

	const initializeContext = () => {
		setLoading(true);
		fetchGeotilesLocations()
			.then((res) => {
				setLoading(false);
				setGpsLocations(
					res
						.filter(
							(location) =>
								location.location &&
								location.externalVehicleData.status ===
									ExternalVehicleStatusEnum.active,
						)
						.map((location) => ({
							...location,
							locationType:
								Math.abs(
									moment(location.location.updatedAt).diff(moment(), 'hours'),
								) < 24
									? InterestPointType.signalVehicle
									: InterestPointType.noSignalVehicle,
						})),
				);
			})
			.catch((e) => {
				setLoading(false);
				commonErrorHandler(e);
			});
	};

	useEffect(() => {
		initializeContext();
	}, []);

	useEffect(() => {
		setGpsHistory([]);
		if (selectedMarker) {
			fetchGpsHistory();
		}
	}, [selectedMarker]);

	const fetchGpsHistory = () => {
		if (selectedMarker?._id) {
			setLoadingHistory(true);
			const dias = moment().diff(moment(selectedMarker.createdAt), 'days');
			fetchGeotileHistory(selectedMarker._id, Math.min(dias, 90))
				.then((data) => {
					setLoadingHistory(false);
					setGpsHistory(data.locations);
				})
				.catch((error) => {
					setLoadingHistory(false);
					commonErrorHandler(error);
				});
		} else {
			commonErrorHandler('No hay informacion disponible del dispositivo');
		}
	};

	const contextValue: GeotileMapContextModel = useMemo(
		() => ({
			loading,
			setLoading,
			loadingHistory,
			gpsLocations,
			gpsHistory,
			selectedMarker,
			setSelectedMarker,
			clearContext,
		}),
		[loading, loadingHistory, gpsLocations, gpsHistory, selectedMarker],
	);
	return (
		<geotileMapContext.Provider value={contextValue}>
			{children}
		</geotileMapContext.Provider>
	);
};
